import { CONNECTOR_NAME } from './connectors';
import { DOCUMENTATION } from './Urls';

export const ROUTES = {
  getStarted: 'get-started',
  chatWithHana: 'chat-with-hana',
  overview: 'overview',
  whatsHappening: 'whats-happening',
  meetingOverview: 'meeting-overview',
  memory: 'memory',
  users: 'users',
  spaces: 'spaces',
  reportGroups: 'report-groups',
  connectors: 'connectors',
  help: 'help',
  settings: 'settings',
  savedPrompts: 'saved-prompts',
  tasks: 'tasks',
  tags: 'tags',
  automation: 'automation',
  instructions: 'instructions',
  sprints: 'sprints',
  crm: 'crm',
  invocationHistory: 'invocation-history',
  invocationPlaybook: 'invocation-playbook',
  filePicker: 'file-picker',
  polls: 'polls',
  highValueClients: 'high-value-clients',
  manualVerifications: 'manual-verifications',
  amlVerifications: 'aml-verifications',
  docs: DOCUMENTATION,
};

export const SEARCH_PARAMS = {
  dnsVerify: 'dns-verify',
  redirect: 'redirect',
  entry: 'entry',
  invitationToken: 'invitationToken',
  oauthReauthIntent: 'oauthReauthIntent',
  variant: 'variant',
  reason: 'reason',
};

export enum ENTRY_CASES {
  newOrg = 'newOrg',
  newUser = 'newUser',
  joinOrg = 'joinOrg',
}

export const getConnectorPathName = (connectorType: CONNECTOR_NAME): string => {
  return `${connectorType.toLowerCase()}`;
};

export const PATHS = {
  home: `/`,
  unAuthorized: `/auth`,
  getStarted: `/get-started`,
  chatWithHana: `/chat-with-hana`,
  overview: `/overview`,
  whatsHappening: `/whats-happening`,
  meetingOverview: `/meeting-overview`,
  settings: `/settings`,
  profile: `profile`,
  onBoardRegistration: `/onBoard-registration`,
  reportGroups: `/report-groups`,
  reportMessages: `report-message/groups/:groupId`,
  memoryBatchDetails: `batch/:chunkBatchId`,
  ingestedMemories: `ingested/:chunkBatchId`,
  memoryPageData: `page-data/:chunkBatchId`,
  memorySearch: `search`,
  memory: `/memory`,
  users: `/users`,
  help: `/help`,
  spaces: `/spaces`,
  automation: `/automation`,
  instructions: `/instructions`,
  responsibleAI: `/responsible-ai-use`,
  pricingPlans: `/pricing-plans`,
  tasks: `/tasks`,
  approvals: `/approvals`,
  tags: `/tags`,
  sprints: `/sprints`,
  sprintBoard: `/sprints/:sprintId`,
  sprintBacklog: `/sprints/:sprintId/backlog`,
  payment: `/payment`,
  policyApproval: `/policy-approval`,
  savedPrompts: '/saved-prompts',
  sentPrompt: '/sent-prompts/:promptId',
  crm: `/crm`,
  invocationHistory: `/invocation-history`,
  invocationPlaybook: '/invocation-playbook',
  invocationRecord: '/invocations/:invocationId',
  connectors: '/connectors',
  filePicker: '/file-picker',
  polls: '/polls',
  highValueClients: '/high-value-clients',
  manualVerifications: '/manual-verifications',
  amlVerifications: '/aml-verifications',
  zapierConnector: `connect/${getConnectorPathName(CONNECTOR_NAME.ZAPIER)}`,
  exposeApiConnector: `connect/${getConnectorPathName(CONNECTOR_NAME.EXPOSE_API)}`,
  confluenceConnector: `connect/${getConnectorPathName(CONNECTOR_NAME.CONFLUENCE)}`,
  notionConnector: `connect/${getConnectorPathName(CONNECTOR_NAME.NOTION)}`,
  jiraConnector: `connect/${getConnectorPathName(CONNECTOR_NAME.JIRA)}`,
  asanaConnector: `connect/${getConnectorPathName(CONNECTOR_NAME.ASANA)}`,
  mcpConnector: `connect/mcp`,
  reactivateAccount: `/reactivate-account`,
  noActiveOrganization: `/no-active-organization`,
};
